import React from 'react';
import { marqueeTags } from '../data/mock';

export default function Marquee() {
  const items = [...marqueeTags, ...marqueeTags, ...marqueeTags, ...marqueeTags];
  return (
    <section className="py-8 overflow-hidden border-y border-[color:var(--gold-500)]/10">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((tag, i) => (
          <div key={i} className="flex items-center gap-8 pr-8 shrink-0">
            <span className="font-serif italic text-2xl md:text-3xl text-[color:var(--cream-100)]">
              {tag}
            </span>
            <span className="text-[color:var(--gold-400)] text-xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
